import React from "react";
import { useTranslation } from "react-i18next";

const DataGrid = ({ columns, data, renderRow, onSelectAll, allSelected }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="hidden sm:block">
        <div className="grid grid-cols-12 gap-4 px-4 py-2 bg-gray-100 rounded-t-md">
          {columns.map((col, index) => (
            <div
              key={index}
              className={`col-span-${col.span} ${col.center ? "text-center" : ""}`}
            >
              {col.header}
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-4 mt-4">
        {data.map((row) => renderRow(row))}
      </div>
    </div>
  );
};

export default DataGrid;
